<body>
  <div class="container-fluid h-100 bd fd">
    @if (loading) {
      <app-loading></app-loading>
    }
    @if (!isLandscape) {
      <app-orientation-overlay></app-orientation-overlay>
    }
    <router-outlet></router-outlet>
  </div>
</body>
